module.exports = __webpack_public_path__ + "img/icon_point.1918935e.svg";